import * as HELPER from "../../../src/config/helper";
import PremiumRemittance from './PremiumRemittance';
import OtoRevenueCard from './OtoRevenueCard';
import AgencyPayoutCard from './AgencyPayoutCard'
import InsurerPartnerRemittance from './InsurerPartnerRemittance';
import DealerRemittance from './DealerRemittance';
import AgencyRemittanceCard from './AgencyRemittanceCard';
import {RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES,REMITTANCE_TYPE} from '../../../src/config/constant';
import { useState,useEffect } from "react";
import moment from 'moment';
import secureStorage from "@src/config/encrypt";
import PaymentInfoPopup from '../../../src/lead/common/PaymentInfoPopup';

const RemittanceView = (props: any) => {
  const { isLeadFromAgency,remittanceDetails,setCallReloadApi,callReloadApi,revenue,remittance_status } = props;

  const [selectedFilters, setSelectedFilters] = useState<any>({});
  const [errors,SetErrors] = useState<any>({});
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [isOpsLoggedIn, setIsOpsLoggedIn] = useState(false);
  const [isMakerLoggedIn, setIsMakerLoggedIn] = useState(false);
  const [isCheckerLoggedIn, setIsCheckerLoggedIn] = useState(false);
  const [formReferralChangeDetect, setFormReferralChangeDetect] = useState(false);
  const [formAgencyChangeDetect, setFormAgencyChangeDetect] = useState(false);
  const [viewPaymentInfo, setViewPaymentInfo] = useState(false);
  const [remittanceType, setRemittanceType] = useState<string>("");
  const [currentLoggedInUser, setCurrentLoggedInUser] = useState<number>(0);
  const [roleStatus, setRoleStatus] = useState<any>([]);
  const [isPartnerRemittanceExists , setIsPartnerRemittanceExists] = useState(false);
  const [isReferralRemittanceExists , setIsReferralRemittanceExists] = useState(false);
  const [isAgencyRemittanceExists , setIsAgencyRemittanceExists] = useState(false);

  const handleChange = (selectedValue: any, key: string) => {
    let value = selectedValue;
     if (key === 'referral_fee_date') {
      value = moment(selectedValue).format('YYYY-MM-DD');
    }
    if(key === "referral_remittance" || key === "amount_remitted_to_agency" || key === "amount_received_from_agency"){
      // Remove non-numeric chars except dot
      value = String(selectedValue).replace(/[^0-9.]/g, "");
      // Keep only first dot & max 4 decimals
      const match = value.match(RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES);
      value = match ? match[0] : "";
    }
    if(key === "referral_remittance"){
      setFormReferralChangeDetect(true);
    }else{
      setFormAgencyChangeDetect(true)
    }
    setSelectedFilters((prev: any) => ({
      ...prev,
      [key]: value,
    }));
    SetErrors((prev: any) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[key];
        return updatedErrors;
    });
  }

  /**
   * Check if REM_OPS is logged In
   */
  const checkIfAdminIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "ADMIN"){
      setIsAdminLoggedIn(true);
    }else{
      setIsAdminLoggedIn(false);
    }
  }

  /**
   * Check if REM_OPS is logged In
   */
  const checkIfOpsIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "REM_OPS"){
      setIsOpsLoggedIn(true);
    }else{
      setIsOpsLoggedIn(false);
    }
  }

  /**
     * Check if Maker is logged In
     */
  const checkIfMakerIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "REM_FINANCE_MAKER"){
      setIsMakerLoggedIn(true);
    }else{
      setIsMakerLoggedIn(false);
    }
  }

    /**
     * Check if Checker is logged In
     */
  const checkIfCheckerIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "REM_FINANCE_CHECKER"){
      setIsCheckerLoggedIn(true);
    }else{
      setIsCheckerLoggedIn(false);
    }
  }

  const makePayment = (remitance_type:string) => {
    setRemittanceType(remitance_type);
    setViewPaymentInfo(true);
  }

  const closePaymentPopup = () => {
    setViewPaymentInfo(false);
  }

  const reloadDetail = async () => {
    setCallReloadApi(callReloadApi+1);
  }

  useEffect(() => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    if(remittance_status.length > 0){
      const roleId = authUserInfo?.user_data?.assigned_role_ids;
      const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
      let filteredStatus: any[] = [];
      switch (roleName) {
          case "REM_OPS":
          case "REM_FINANCE_MAKER":
            filteredStatus = (remittance_status || []).filter((item: any) => item.role_id === roleId).map((item: any) => item.value);
              break;
          case "REM_FINANCE_CHECKER":
              // show only records matching user's role
              filteredStatus = (remittance_status || []).filter((item: any) => item.role_id === roleId && item.label === "Ready").map((item: any) => item.value);
              break;
          default:
            filteredStatus = [];
          break;
      }
      setRoleStatus(filteredStatus);
    }
    setCurrentLoggedInUser(+authUserInfo?.user_data?.user_id)
    checkIfAdminIsLoggedIn()
    checkIfOpsIsLoggedIn()
    checkIfMakerIsLoggedIn()
    checkIfCheckerIsLoggedIn()
     // eslint-disable-next-line
     },[remittance_status])

  useEffect(() => {
    if (Array.isArray(remittanceDetails) && remittanceDetails.length > 0) {
      setIsReferralRemittanceExists(
        remittanceDetails.some((b: any) => b.remittance_type_name === REMITTANCE_TYPE['referral'])
      );
      props.setIsReferralRemittanceExists(
        remittanceDetails.some((b: any) => b.remittance_type_name === REMITTANCE_TYPE['referral'])
      )
      setIsAgencyRemittanceExists(
        remittanceDetails.some((b: any) => b.remittance_type_name === REMITTANCE_TYPE['agency'])
      );
      props.setIsAgencyRemittanceExists(
        remittanceDetails.some((b: any) => b.remittance_type_name === REMITTANCE_TYPE['agency'])
      )
      setIsPartnerRemittanceExists(
        remittanceDetails.some((b: any) => b.remittance_type_name === REMITTANCE_TYPE['partner'])
      );
      props.setIsPartnerRemittanceExists(
        remittanceDetails.some((b: any) => b.remittance_type_name === REMITTANCE_TYPE['partner'])
      )
    } else {
      setIsReferralRemittanceExists(false);
      setIsAgencyRemittanceExists(false);
      setIsPartnerRemittanceExists(false);
    }
  },[remittanceDetails])
  return (
    <>
      {viewPaymentInfo && <PaymentInfoPopup viewPaymentInfo={viewPaymentInfo} handleViewPaymentInfo={closePaymentPopup} from={"InsurerPartnerRemittance"} remittanceType={remittanceType} reloadDetail={reloadDetail}/>}
      <div className="remittance-wrapper">
        <div id="premium">
          <PremiumRemittance revenue={revenue} isLeadFromAgency={isLeadFromAgency}></PremiumRemittance>
        </div>
        <div id="oto">
          <OtoRevenueCard revenue={revenue} remittanceDetails={remittanceDetails}></OtoRevenueCard>
        </div>

        {
          isLeadFromAgency &&
          <div id="agencyPayout">
            <AgencyPayoutCard revenue={revenue} remittanceDetails={remittanceDetails}></AgencyPayoutCard>
          </div>
        }
        {
          isPartnerRemittanceExists &&
          <div id="insurerPartner">
          <InsurerPartnerRemittance remittanceDetails={remittanceDetails} callReloadApi={callReloadApi} setCallReloadApi={setCallReloadApi} isAdminLoggedIn={isAdminLoggedIn} isOpsLoggedIn={isOpsLoggedIn} setIsOpsLoggedIn={setIsOpsLoggedIn} checkIfOpsIsLoggedIn={checkIfOpsIsLoggedIn} isMakerLoggedIn={isMakerLoggedIn} isCheckerLoggedIn={isCheckerLoggedIn} makePayment={makePayment} currentLoggedInUser={currentLoggedInUser} roleStatus={roleStatus}></InsurerPartnerRemittance>
          </div>

        }
        {
          isReferralRemittanceExists &&
          <div id="dealer">
          <DealerRemittance remittanceDetails={remittanceDetails} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} errors={errors} setErrors={SetErrors} callReloadApi={callReloadApi} setCallReloadApi={setCallReloadApi} handleChange={handleChange} isAdminLoggedIn={isAdminLoggedIn} isOpsLoggedIn={isOpsLoggedIn} checkIfOpsIsLoggedIn={checkIfOpsIsLoggedIn} isMakerLoggedIn={isMakerLoggedIn} isCheckerLoggedIn={isCheckerLoggedIn} formReferralChangeDetect={formReferralChangeDetect} setFormReferralChangeDetect={setFormReferralChangeDetect} makePayment={makePayment} currentLoggedInUser={currentLoggedInUser} roleStatus={roleStatus}></DealerRemittance>
          </div>

        }
        {
          isLeadFromAgency && isAgencyRemittanceExists &&
          <div id="agencyRemit">

          <AgencyRemittanceCard revenue={revenue}  remittanceDetails={remittanceDetails} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} errors={errors} setErrors={SetErrors} callReloadApi={callReloadApi} setCallReloadApi={setCallReloadApi} handleChange={handleChange} isAdminLoggedIn={isAdminLoggedIn} isOpsLoggedIn={isOpsLoggedIn} checkIfOpsIsLoggedIn={checkIfOpsIsLoggedIn} isMakerLoggedIn={isMakerLoggedIn} isCheckerLoggedIn={isCheckerLoggedIn} formAgencyChangeDetect={formAgencyChangeDetect} setFormAgencyChangeDetect={setFormAgencyChangeDetect} makePayment={makePayment} currentLoggedInUser={currentLoggedInUser} roleStatus={roleStatus}></AgencyRemittanceCard>
          </div>

        }
      </div>
    </>
  );
};

export default RemittanceView;
